import { useState } from "react";
import { Outlet } from "react-router-dom";

import { Box, Grid, makeStyles } from "@material-ui/core";

import { PAGES } from "../../pages";
import { Header } from "../dashboard/Header";
import { LeftNav } from "../dashboard/LeftNavigator";
import TaskIcon from "../../assets/images/icons/nav/task.svg";
import SettingsIcon from "../../assets/images/icons/nav/settings.svg";
import BuildingIcon from "../../assets/images/icons/nav/building.svg";
import ReportsIcon from "../../assets/images/icons/nav/reports.svg";
import AssistanceIcon from "../../assets/images/icons/nav/assistant.svg";
import reportSelected from "../../assets/images/icons/nav/reports-selected.svg";
import assistantSelected from "../../assets/images/icons/nav/assistant-selected.svg";
import SettingsIconSelected from "../../assets/images/icons/nav/settings-selected.svg";
import TaskIconSelected from "../../assets/images/icons/nav/task-selected.svg";
import BuildingIconSelected from "../../assets/images/icons/nav/building-selected.svg";

const NAV_ITEMS = [
  {
    icon: TaskIcon,
    iconSelected: TaskIconSelected,
    text: "Tasks",
    path: `${PAGES.workspace.index}/${PAGES.workspace.tasks}`,
    id: "task-nav",
  },
  {
    icon: BuildingIcon,
    iconSelected: BuildingIconSelected,
    text: "Buildings",
    path: `${PAGES.workspace.index}/${PAGES.workspace.buildings}`,
    id: "buildings-nav",
  },
  {
    icon: AssistanceIcon,
    iconSelected: assistantSelected,
    text: "Assistance",
    path: `${PAGES.workspace.index}/${PAGES.workspace.assistance}`,
    id: "assistance-nav",
  },
  {
    icon: ReportsIcon,
    iconSelected: reportSelected,
    text: "Reports",
    path: `${PAGES.workspace.index}/${PAGES.workspace.reports}`,
    id: "reports-nav",
  },
  {
    icon: SettingsIcon,
    iconSelected: SettingsIconSelected,
    text: "Settings",
    path: `${PAGES.workspace.index}${PAGES.workspace.settings.index}`,
  },
];

const useStyles = makeStyles(() => ({
  box: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1,
    flexWrap: "nowrap",
    overflow: "auto",
  },
  gridContent: {
    flexGrow: 1,
    overflow: "auto",
    backgroundColor: "#F8F8F8",
  },
}));

export const WorkspaceLayout = () => {
  const classes = useStyles();
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Box className={classes.box}>
      <Header onHoverLogo={() => setCollapsed(!collapsed)} />
      <Grid container className={classes.content}>
        <Grid item>
          <LeftNav collapsed={collapsed} navItems={NAV_ITEMS} />
        </Grid>

        <Grid item className={classes.gridContent}>
          <Outlet />
        </Grid>
      </Grid>
    </Box>
  );
};
